
const digest = 'c8d91be29b9a14d180b0f4fd5a2578a08441d06e12768c6c02a6d4365fd1dcc6';
const classes = {"wrapper":"_wrapper_jdlk9_1","folderName":"_folderName_jdlk9_6","folderContent":"_folderContent_jdlk9_16"};
const css = `._wrapper_jdlk9_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
}
._wrapper_jdlk9_1 ._folderName_jdlk9_6 {
  font-size: 16px;
  font-weight: 500;
  padding: 18px 12px;
  gap: 15px;
  display: flex;
  align-items: center;
  border: 1px solid #eaedf3;
  background-color: #fff8e3;
}
._wrapper_jdlk9_1 ._folderContent_jdlk9_16 {
  display: flex;
  flex-direction: column;
  padding: 12px;
  border: 1px solid #eaedf3;
  border-top: 0;
  margin: 0 0 24px 0;
  background-color: #fbfbfd;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  